export default __webpack_public_path__ + "354501bac435c3264834b80301089bad.woff";